import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from "lucide-react";
import { company } from "../mock/mock";

const serviceLinks = [
  { label: "For Insurance Companies", to: "/for-insurance-companies" },
  { label: "For Doctors", to: "/for-doctors" },
  { label: "For Hospitals", to: "/for-hospitals" },
  { label: "For Orthodontists", to: "/for-orthodontists" },
  { label: "For Attorneys", to: "/for-attorneys" },
  { label: "For Contractors", to: "/for-contractors" },
];

const companyLinks = [
  { label: "What We Do?", to: "/what-we-do" },
  { label: "About Us", to: "/about" },
  { label: "Debt Collection", to: "/debt-collection-services" },
  { label: "Leads on Demand", to: "/leads-on-demand" },
  { label: "B2B Sales Meetings", to: "/b2b-sales-meetings" },
  { label: "HIPAA", to: "/hipaa" },
  { label: "Blog", to: "/blog" },
  { label: "Jobs", to: "/jobs" },
  { label: "Our Brands", to: "/our-brands" },
];

const Footer = () => {
  return (
    <footer className="bg-navy-dark text-white/75">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-3 mb-5">
            <div className="w-12 h-12 rounded-lg bg-white flex items-center justify-center p-1.5">
              <img src="/logo.webp" alt="Mid Atlantic logo" className="w-full h-full object-contain" />
            </div>
            <div className="font-heading font-extrabold text-white text-[15px] leading-tight">
              Mid Atlantic
              <div className="text-[11px] font-semibold text-white/60 uppercase tracking-wide">
                Business Management
              </div>
            </div>
          </div>
          <p className="text-sm leading-relaxed mb-5">
            Affordable, scalable and virtual contact centre staffing. North Carolina's best
            outsourcing solutions with the lowest pricing and highest quality.
          </p>
          <div className="flex items-center gap-3">
            {[
              { Icon: Facebook, href: company.social.facebook },
              { Icon: Instagram, href: company.social.instagram },
              { Icon: Linkedin, href: company.social.linkedin },
            ].map(({ Icon, href }, i) => (
              <a
                key={i}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-gold hover:text-navy-dark transition-colors"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        {/* Services */}
        <div>
          <h4 className="text-white font-heading font-semibold text-sm uppercase tracking-wide mb-5">
            Services
          </h4>
          <ul className="space-y-3 text-sm">
            {serviceLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-gold-light transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Company */}
        <div>
          <h4 className="text-white font-heading font-semibold text-sm uppercase tracking-wide mb-5">
            Company
          </h4>
          <ul className="space-y-3 text-sm">
            {companyLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-gold-light transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-white font-heading font-semibold text-sm uppercase tracking-wide mb-5">
            Get In Touch
          </h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <MapPin size={18} className="text-gold shrink-0 mt-0.5" />
              <span>{company.addressUS}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={18} className="text-gold shrink-0" />
              <a href={`tel:${company.phoneRaw}`} className="hover:text-gold-light transition-colors">
                {company.phone}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={18} className="text-gold shrink-0" />
              <a href={`mailto:${company.email}`} className="hover:text-gold-light transition-colors">
                {company.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/55">
          <p>© 2018-2026 Mid Atlantic Business Management Inc — All Rights Reserved. Also doing business as: Midatlantic B2B</p>
          <div className="flex items-center gap-5">
            <Link to="/policies" className="hover:text-gold-light transition-colors">
              Policies
            </Link>
            <Link to="/our-brands" data-testid="footer-our-brands-link" className="hover:text-gold-light transition-colors">
              Our Brands & Corporate Relationship
            </Link>
            <Link to="/contact" className="hover:text-gold-light transition-colors">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
